import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";

const Ctx = createContext(null);

export function UserProvider({ children }) {
  const { isSignedIn, isLoaded } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [favIds, setFavIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!isSignedIn) { setMe(null); setFavIds([]); return; }
    try {
      const m = await api("get", "/me");
      setMe(m);
      setFavIds(m.status === "approved" ? (await api("get", "/favorites")).ids : []);
    } catch (e) {
      toast.error(errMsg(e));
    }
  }, [isSignedIn, api]);

  useEffect(() => { if (isLoaded) refresh(); }, [isLoaded, refresh]);

  const toggleFavorite = async (id) => {
    if (!isSignedIn) { toast("Accedi per salvare i preferiti"); return false; }
    const r = await api("post", `/favorites/${id}`);
    setFavIds((prev) => (r.favorite ? [...prev, id] : prev.filter((x) => x !== id)));
    toast.success(r.favorite ? "Aggiunto ai preferiti" : "Rimosso dai preferiti");
    return true;
  };

  return <Ctx.Provider value={{ me, setMe, refresh, favIds, toggleFavorite, isSignedIn, isLoaded }}>{children}</Ctx.Provider>;
}

export const useUser = () => useContext(Ctx);
